export const cdsOverlayId = "cds-overlay";

export const convert64 = (data: string) => window.btoa(encodeURIComponent(data));

export const decode64 = (data: string) => decodeURIComponent(window.atob(data));

export const getEncodedData = (key: string) => {
  const value = sessionStorage.getItem(key);
  return value ? JSON.parse(decode64(value)) : null;
}

export const setEncodedData = (key: string, data: any) => {
  sessionStorage.setItem(key, convert64(JSON.stringify(data)));
}

/**
 * This initializes the configuration of an overlay on the screen
 */
export const insertOverlay = (apendToElement?: HTMLBodyElement) => {
  const node = document.createElement("div");
  node.id = cdsOverlayId;
  if (apendToElement) {
    apendToElement.appendChild(node); // background:" + backgroundColor + " url(" + gifLocation + ") center center no-repeat;
  } else {
    const el = document.getElementsByTagName("body")[0];
    el.appendChild(node); // background:" + backgroundColor + " url(" + gifLocation + ") center center no-repeat;
  }

  const css = "#cds-overlay {width: 100%; height: 100%; position: fixed; display: none; top: 0; left: 0; right: 0;bottom: 0;z-index: 999;cursor: pointer;}";
  const head: any = document.head || document.getElementsByTagName("head")[0];
  const style: any = document.createElement("style");

  style.type = "text/css";

  if (style.styleSheet) {
    // This is required for IE8 and below.
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }

  head.appendChild(style);

  return Promise.resolve();
}

/**
* This starts overlay on the screen
*/
export const startOverlay = (overlay?: any) => {
  const element = document.getElementById(overlay?.id || cdsOverlayId);

  if (element) {
    element.style.background = overlay?.backgroundColor && `${overlay.backgroundColor} url(${overlay.animation}) center center no-repeat`;
    element.style.display = "block";
    element.style.opacity = overlay?.opacity;
  }

  return Promise.resolve();
}

/**
 * Ends overlay on the screen by modifying ces rule
 */
export const endOverlay = (overlayConfig?: any): void => {
  const overlay = document.getElementById(overlayConfig?.id || cdsOverlayId);

  if (overlay) {
    overlay.style.display = "none";
  }
}

/**
 * Transform the error on a key. This key will be used to get a translation value on translate bundle
 * @param error
 */
export const formatError = (error: any): Array<any> => {
  if (typeof error === "object") {
    let arrayBuildId: any[] = [];
    const group = error.group ? `${error.group}.` : '';
    const context = error.context ? `${error.context}.` : '';
    const resource = /[^/]*$/.exec(error.resource)![0];
    const baseBuildId = `${group}${context}${resource}.${error.message}`;
    if (error.objects != null && error.objects.length > 0 && error.objects != undefined) {
      error.objects.forEach((element: any) => {
        arrayBuildId.push(`${baseBuildId}.${element.name}.${element.value}`);
      });
    } else {
      arrayBuildId = [baseBuildId];
    }
    return arrayBuildId;
  }

  return [error];
}

/**
 * Get the currently version from SDK
 */
export const getVersion = (): string => process.env.SDK_VERSION || '';

export const fetchDataTransformer = async (response: any) => {
  const { status } = response;
  const json = await response.json();
  if (status !== 200 && status !== 201) throw { status, data: json };
  // Some GCP endpoints wrap their payload as { status: 0, data: <payload> }.
  // Auth endpoints (registration, login) also return status: 0 on success but
  // carry token/refreshToken at the top level alongside data — those must NOT
  // be unwrapped, or submitFormNew's token/refreshToken extraction silently
  // gets nothing back. Only unwrap the plain { status: 0, data } envelope.
  const data =
    json !== null &&
    typeof json === 'object' &&
    json.status === 0 &&
    'data' in json &&
    !('token' in json)
      ? json.data
      : json;
  return { status, data };
}

export const customSetTimeout = (func: any, time: any): any => {
  const max_timeout = 0x7FFFFFFF;
  if (time > max_timeout) {
    return setTimeout(() => {
      const left = time - max_timeout;
      customSetTimeout(func, left);
    }, max_timeout);
  } else {
     return setTimeout(func, time);
  }
}